export default {
  sort: 1,
  name:"pre-order-list",
  path:"/preOrderList",
  component: () => import('@/views/new/preOrderList/preOrderList.vue')

}



// WEBPACK FOOTER //
// ./src/router/modules/preOrderList.js